var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "main-content flex-1 bg-gray-100 mt-12 md:mt-10 pb-24 md:pb-5 overflow-y-auto "
    },
    [
      _vm._m(0),
      _vm._v(" "),
      _vm.isArtistInApproval
        ? _c("alert", { staticClass: "m-4", attrs: { variant: "warning" } }, [
            _vm._v(
              "\n    Your account is in approval stage. Our team is reviewing your artist application and will follow up with the next steps.\n  "
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.isArtist
        ? _c("statistic-admin", { attrs: { "is-loaded": !_vm.isArtist } })
        : _vm._e(),
      _vm._v(" "),
      _vm.isArtist
        ? _c("statistic-artist", { attrs: { "is-loaded": _vm.isArtist } })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "bg-blue-800 p-2 shadow text-xl text-white" },
      [_c("h3", { staticClass: "font-bold pl-2" }, [_vm._v("Analytics")])]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-35041886", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35041886","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Statistic.vue
// module id = null
// module chunks = 